<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Estoque de Maquinas</h3>
        </div>

        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
            </button>
            <button v-if="countFilter > 0" type="button" class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom title="Limpar filtros" @click="ResetFilter()">
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Máquinas</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0">Id</th>
                    <th scope="col" class="border-0 text-left">Modelo</th>
                    <th scope="col" class="border-0">Software</th>
                    <th scope="col" class="border-0">Status</th>
                    <th scope="col" class="border-0">Numero de Série</th>
                    <th scope="col" class="border-0"></th>

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(maquina, index) in maquinas" :key="index">
                    <td>{{ maquina.Id }}</td>
                    <td>{{ maquina.MaquinaModelo.Nome }}</td>
                    <td>{{ maquina.MaquinaDesenvolvedorSoftware.Nome }}</td>
                    <td>{{ maquina.Situacao.Nome }}</td>
                    <td>{{ maquina.NumeroSerie }}</td>
                    <td>
                      <div class="dropdown">
                        <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Opções
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a v-if="$isAuthorize('Maquina', 'Update')" class="dropdown-item" href="#"
                            v-on:click="OpenMaquina($event, index)">
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <!-- <a
                            v-if="$isAuthorize('Maquina', 'Excluir')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="ConfirmDeleteMaquina(maquina.Nome, maquina.Id)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a> -->
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="maquinas == undefined || maquinas == null || maquinas.length == 0">
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination class="float-right" v-model="pagination.PageNumber" :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage" aria-controls="my-table"></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal size="lg" id="mFormMaquina" @shown="$refs.infoMaquinaNumeroSerie.focus()" :title="modalTitle"
      :no-close-on-backdrop="true" :no-close-on-esc="false">
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <!-- Modelo -->
        <ValidationObserver tag="form" ref="validatedMaquinaForm">
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Modelo</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select v-model="infoMaquina.MaquinaModelo.Id"
                  :class="validatedMaquinaForm | showValidateError(invalid)" :value="null" :disabled="isSeeing">
                  <option :value="3" selected>GPOS720</option>
                  <option :value="2">GPOS700X</option>

                </d-select>
                <div class="invalid-feedback d-block" v-if="validatedMaquinaForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label>Desenvolvedor Software</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select v-model="infoMaquina.MaquinaDesenvolvedorSoftware.Id"
                  :class="validatedMaquinaForm | showValidateError(invalid)" :value="null" :disabled="isSeeing">
                  <option :value="2" selected>Payer</option>
                  <option :value="1">Cielo</option>
                </d-select>
                <div class="invalid-feedback d-block" v-if="validatedMaquinaForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
        <!-- NumeroSerie -->
        <d-form-row>
          <d-col md="12">
            <label>Numero de Série</label>
            <input id="infoMaquinaNumeroSerie" ref="infoMaquinaNumeroSerie" minlength="10" maxlength="16"
              placeholder="Numero de Série" type="text" class="form-control" v-model="infoMaquina.NumeroSerie"
              v-on:keyup.enter="SaveMaquina(true)" :disabled="isSeeing" />
          </d-col>
        </d-form-row>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" variant="success" @click="SaveMaquina()" v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal">
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="mFilter" title="Filtros" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col md="12" class="form-group">
          <label>Situacao</label>
          <d-select v-model="filter.Situacao" :value="null" :disabled="isSeeing">
            <option :value="null" selected>Selecione</option>
            <option :value="1" selected>Em estoque</option>
            <option :value="2" selected>Em operação</option>
            <option :value="3" selected>Em transporte</option>
            <option :value="4" selected>Em manutenção</option>

          </d-select>
        </d-col>
        <d-col md="12" class="form-group">
          <input placeholder="Numero de Série" type="text" class="form-control" v-model="filter.NumeroSerie"
            v-on:keyup.enter="Filter()" />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar" @click="Filter()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button variant="primary" class="input-group-text" v-b-tooltip.hover.bottom title="Limpar filtros"
          @click="ResetFilter()">
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a v-if="$isAuthorize('Maquina', 'Add')" href="#" class="btn-float success" v-b-tooltip.hover title="Nova Maquina"
      v-on:click="OpenMaquina($event)">
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../../utils/functions.js";
import dateField from "../../common/date-field";
export default {
  name: "deals-maquina",
  data: function () {
    return {
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      modalTitle: "Nova Maquina",
      countFilter: 0,
      filter: {
        Situacao: null,
        NumeroSerie: null,
      },
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      pOpened: null,
      maquinas: [],
      infoMaquina: {
        Id: 0,
        Situacao: {
          Id: 0,
          Nome: null
        },
        MaquinaModelo: {
          Id: 3
        },
        MaquinaDesenvolvedorSoftware: {
          Id: 2
        },
      },
      isSeeing: false,
      validatedMaquinaForm: false,
    };
  },
  filters: {

  },
  components: {
    dateField
  },
  watch: {

    "pagination.PageNumber": function () {
      this.MaquinaList();
    },
    "pagination.RowsPerPage": function () {
      this.MaquinaList();
    }
  },
  mounted() {
    this.MaquinaList();
  },
  methods: {
    OpenMaquina: function (e, i, view) {
      if (e != undefined || e != null) {
        e.preventDefault();
      }
      //   this.StatusList();
      this.validatedMaquinaForm = false;
      if (view == undefined && i != undefined) {
        this.ResetInfoMaquina();

        // Edit
        this.pOpened = i;
        this.isSeeing = false;
        this.modalTitle = "Editar Maquina";
        this.infoMaquina = Object.assign({}, this.maquinas[i]);

      } else {
        // Add new
        this.ResetInfoMaquinaNew();
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Nova Maquina";
      }
      this.$bvModal.show("mFormMaquina");
    },
    OpenModalFilter: function () {
      //   this.StatusList();
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.MaquinaList();
    },
    ResetFilter: function () {
      this.filter = {
        Situacao: {
          Id: 0,
          Nome: null
        },
        NumeroSerie: null
      };
      this.MaquinaList();
    },
    ResetInfoMaquina: function () {
      this.infoMaquina = {
        Id: 0,
        NumeroSerie: null,
        Situacao: {
          Id: 1,
          Nome: null
        },
        MaquinaModelo: {
          Id: 3
        },
        MaquinaDesenvolvedorSoftware: {
          Id: 2
        },
      };
    },
    ResetInfoMaquinaNew: function () {
      this.infoMaquina.Id = 0;
      this.infoMaquina.NumeroSerie = null;

    },
    SaveMaquina: function (wasEnterPressed) {
      this.validatedMaquinaForm = true;

      this.$refs.validatedMaquinaForm.validate().then(isValid => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add

            this.$store.dispatch("AddMaquina", this.infoMaquina)
              .then(() => {
                this.$makeToast("A máquina foi cadastrada com sucesso.", "success", "Máquina cadastrada");
                this.SendBeepAudio("successBeep");
              })
              .catch(error => {
                this.$makeToast(undefined, "danger", "Erro ao cadastrar a maquina", error);
                this.SendBeepAudio("errorBeep");
              })
              .finally(() => {
                this.MaquinaList();
                this.$bvModal.hide("mFormMaquina");
                if (wasEnterPressed == true) {
                  this.OpenMaquina();
                }
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store.dispatch("UpdateMaquina", this.infoMaquina)
              .then(() => {
                this.$makeToast("A máquina foi atualizado com sucesso.", "success", "Máquina atualizada");
                this.MaquinaList();
                this.$bvModal.hide("mFormMaquina");
              })
              .catch(error => {
                this.$makeToast(undefined, "danger", "Erro ao atualizar a máquina", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetParamsMaquina(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Situacao": this.filter.Situacao,
        "Object.NumeroSerie": this.filter.NumeroSerie,
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },
    MaquinaList: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Situacao)) this.countFilter++;
      if (hasValue(this.filter.NumeroSerie)) this.countFilter++;
      this.loadingList = true;
      const data = this.GetParamsMaquina();
      this.$store.dispatch("ListMaquina", { params: data })
        .then(response => {
          this.maquinas = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar as máquinas", error);
        })
        .finally(() => (this.loadingList = false));
    },
    // Ainda não está sendo utilizado
    ConfirmDeleteMaquina: function (description, id) {
      this.$makeMsgBox("Você tem certeza que deseja remover " + description + " ?", "Confirmar", this.DeleteMaquina, id);
    },
    // Ainda não está sendo utilizado
    DeleteMaquina: function (id) {
      this.loadingList = true;
      this.$store.dispatch("DeleteMaquina", { id: id })
        .then(() => {
          this.$makeToast("A máquina foi removida com sucesso.", "success", "Máquina removida");
          this.MaquinaList();
          this.$bvModal.hide("mFormMaquina");
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao remover a maquina", error);
        })
        .finally(() => (this.loadingList = false));
    },
    // Ainda não está sendo utilizado
    StatusList: function () {
      this.loadingList = true;

      this.$store.dispatch("ListMaquinaStatus", {})
        .then(response => {
          this.banks = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar a lista de Status", error);
        })
        .finally(() => (this.loadingList = false));
    },
    SendBeepAudio: function(beepType) {
      var filename = require('@/assets/audios/' + beepType + '.mp3');
      var audio = new Audio(filename);
      audio.play(); 
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Maquina/Maquina.vue